// Componente raíz de la aplicación
import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { InactivityFlowService } from './features/quoter/services/inactivity-flow.service';
import { QueryParamsPersistenceService } from './features/quoter/services/query-params-persistence.service';
import { DevtoolsDetectorService } from './shared/services/devtools/devtools.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],
  template: `<router-outlet />`,
})
export class App {
  private readonly inactivityFlow = inject(InactivityFlowService);
  private readonly queryParamsPersistence = inject(QueryParamsPersistenceService);
  private readonly devtoolsDetector = inject(DevtoolsDetectorService);

  constructor() {
    this.inactivityFlow.init();
    this.queryParamsPersistence.init();
    this.devtoolsDetector.init();
  }
}
